import { render } from "./SearchTenant.vue?vue&type=template&id=637480ee&scoped=true&ts=true"
import script from "./SearchTenant.vue?vue&type=script&lang=ts"
export * from "./SearchTenant.vue?vue&type=script&lang=ts"

import "./SearchTenant.vue?vue&type=style&index=0&id=637480ee&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637480ee"]])

export default __exports__